var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96877 8.7891H5.82034C5.38886 8.7891 5.0391 9.13887 5.0391 9.57035V15.0782C5.0391 15.5097 5.38886 15.8594 5.82034 15.8594H14.2187C14.6502 15.8594 15 15.5097 15 15.0782V9.57035C15 9.13887 14.6502 8.7891 14.2187 8.7891H12.1094C11.295 8.7891 10.5591 9.13234 10.0391 9.68168C9.51895 9.13234 8.78314 8.7891 7.96877 8.7891ZM9.25782 14.2969H6.60159V10.3516H7.96877C8.67954 10.3516 9.25782 10.9299 9.25782 11.6407V14.2969ZM10.8203 11.6407C10.8203 10.9299 11.3986 10.3516 12.1094 10.3516H13.4375V14.2969H10.8203V11.6407ZM19.6664 6.58629L10.4477 0.140977C10.1788 -0.0469922 9.82122 -0.0469922 9.55235 0.140977L0.333658 6.58629C-0.0199727 6.83352 -0.106183 7.32059 0.141042 7.67422C0.388306 8.02781 0.875334 8.11402 1.22897 7.86684L1.95318 7.36051V19.2188C1.95318 19.6502 2.30294 20 2.73442 20H17.2656C17.6971 20 18.0468 19.6502 18.0468 19.2188V7.36051L18.771 7.86684C18.9073 7.96211 19.0634 8.00789 19.218 8.00789C19.4645 8.00789 19.707 7.89152 19.859 7.67422C20.1062 7.32063 20.0199 6.83356 19.6664 6.58629V6.58629ZM16.4843 18.4375H3.51567V6.26809L10 1.73453L16.4843 6.26809V18.4375Z",
    fill: "#9C92E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.032da114dd7e23e5740616c2fc3042a7.svg";
export { ForwardRef as ReactComponent };